import { render } from "./AppProfile.vue?vue&type=template&id=62a2ebf4&scoped=true"
import script from "./AppProfile.vue?vue&type=script&lang=js"
export * from "./AppProfile.vue?vue&type=script&lang=js"

import "./AppProfile.vue?vue&type=style&index=0&id=62a2ebf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62a2ebf4"]])

export default __exports__